'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'UnitRestService',
    function ($modal, UnitRestService) {

        return {
            edit: edit,
            create: create,
            api: UnitRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/unit-modal-create.html'),
                controller: 'UnitModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    unit: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/unit-modal-create.html'),
                controller: 'UnitModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    unit: function () {
                        return item;
                    }
                }
            });
        }

    }];